/**
 * @generated SignedSource<<14709da0eb3016ad6bd6108dd5e1a3f7>>
 * @relayHash 19c1ac51d55aceeac9b764c8dbf700c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c263536ede2352ca5302d36a6156cce8b87dc70dc5b82c03bad3714cd1e3d650

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessListEmbedAppQuery } from './JiraBusinessListEmbedAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessListEmbedAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c263536ede2352ca5302d36a6156cce8b87dc70dc5b82c03bad3714cd1e3d650",
    "metadata": {},
    "name": "JiraBusinessListEmbedAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
